import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, FormGroup, Checkbox, Tooltip } from '@material-ui/core';
import { NotificationManager } from 'react-notifications';
import { CloudUploadFill } from 'styled-icons/bootstrap';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import LocationSearchInput from '../components/jobs/locationSearchInput';
import database, { storage } from '../../system/model/firebase/firebase';
import Editor from '../components/jobs/editor';
import { palette } from '../../system/styles/styles';
import { createNew, updateVacancy } from '../../redux/actions/vacanciesActions';
import { onChangeLoad } from '../../redux/reducer/loadReducer';
import { jobTypes } from '../../redux/reducer/jobsReducer';

const ContainerForm = styled.main`
  font-family: futura-pt, sans-serif;
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 2fr 1fr;
  grid-column-gap: 1rem;
  background-color: ${palette.colorBackground};
  // estilos para el combo de seleccionar plantilla de bb
  .addCompany {
    display: grid;
    margin-top: 20px;
    height: 30px;

    h6 {
      font-family: ${palette.reg};
      font-size: 14px;
      width: 100%;
      text-align: justify !important;
    }

    select {
      font-family: ${palette.reg};
      font-size: 16px; 
    }
  }

  .noneDisplay {
    display: none;
  }

  // Estilos para el select Divisa

  .typeCurrency {
    border: solid 1px #d3d5d8;
    font-size: 14px;
    margin: 0 5px;
    width: 150px;
    height: 25px;
    line-height: 1.7;
    border-radius: 4px;
    padding: 0;

    &:focus {
      outline: none;
    }

    option {
      font-size: 14px;
    }
  }

  // estilos para template jobs
  .formControl {
    //border-bottom: 1px solid #000;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-self: center;
  }

  .filter {
    width: 20vw;
    border: none;
    position: relative;
  }

  .iconFil {
    color: rgba(76, 88, 102, 0.4);
    align-self: center;
    position: absolute;
    width: 2vw;
  }

  label {
    font-size: 1.2rem;
  }

  form {
    box-shadow: ${palette.lightBS};
    padding: 32px;
    background-color: ${palette.white};
    width: 90%;
    height: calc(97vh - 115px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-self: end;
    align-self: center;
    &::-webkit-scrollbar {
      width: 0.8em;
      height: 0.8em;
    }

    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.8rem;
    }
  }

  .work {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border: solid 1px ${palette.lightgray};
    border-radius: 8px;
    font-size: 16px;

    &:first-child {
      border-top-left-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }
  }

  select {
    box-sizing: border-box;
    border: 1px solid #d3d5d8;
    font-size: 1rem;
    padding: 10px;
    line-height: 1.7;
    border-radius: 4px;
    margin-bottom: 16px;
    width: 100%;
  }

  .work_selected {
    width: 100%;
    background-color: ${palette.lightpurple} !important;
    color: ${palette.purple};
    padding-top: 14px;
    padding-bottom: 14px;
    font-size: 16px;
  }

  .salary {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border: solid 1px ${palette.lightgray};
    border-radius: 8px;

    &:first-child {
      border-top-left-radius: 8px !important;
      border-bottom-left-radius: 8px !important;
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
    }

    button {
      padding-top: 14px;
      padding-bottom: 14px;
      font-size: 14px;
      width: 100%;
      background-color: ${palette.white};
      cursor: pointer;
      border: none;
      &:focus {
        outline: none;
      }
    }
  }

  .salary_selected {
    width: 100%;
    background-color: ${palette.lightpurple} !important;
    color: ${palette.purple};
    padding-top: 14px;
    padding-bottom: 14px;
  }

  .listEmailsItems {
    display: grid;
    margin-bottom: 10px;
    background-color: ${palette.lightBlue};
    grid-template-columns: 70% 30%;

    p {
      font-size: 14px;
      color: ${palette.blue};
    }

    button {
      background-color: ${palette.lightBlue} !important;
      text-decoration: none;
      font-size: 14px;
      color: ${palette.blue} !important;

      &:focus {
        outline: none;
      }
    }
  }

  .notify {
    width: 100%;

    button {
      display: block;
      background-color: ${palette.blue};
      color: ${palette.white};
      font-size: 14px;
      text-align: right;

      &:focus {
        outline: none;
      }
    }

    label {
      margin: 10px 0px;
      font-size: 14px;
    }

    input {
      font-size: 14px;

      &:focus {
        outline: none;
      }
    }

    p {
      font-size: 14px;
    }
  }

  .form-group {
    position: relative;
    font-size: 14px;
  }

  .visible {
    display: block;
    width: 100%;
  }

  .hidden {
    visibility: hidden;
    display: none !important;
  }

  .inputSalarios {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 1rem;
  }

  .jobcard {
    margin-top: 32px;
    display: grid;
    grid-template-columns: 1fr 2fr;
    height: 125px;
    border-radius: 8px;
    box-shadow: ${palette.lightBS};
    color: #333333;
    background-color: ${palette.white};

    &:hover {
      text-decoration: none;
      color: #333333;
    }

    img {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      width: 100%;
      object-fit: cover;
      height: 125px;
    }
  }

  .jobcard-container {
    padding: 16px;
    align-self: center;

    h3 {
      font-size: 14px;
      font-family: futura-pt, sans-serif;
    }

    h4 {
      font-size: 16px;
      font-family: bold;
      font-family: futura-pt, sans-serif;
    }
  }
  #saveButton {
    border: none;
    cursor: pointer;
    font-size: 18px;
    align-self: flex-end;
    margin-right: 15px;
    width: 120px;
  }
  .upload,
  #saveButton {
    margin-top: 20px;
    text-align: center;
    background-color: ${palette.blue};
    padding: 8px;
    color: ${palette.white};
    border-radius: 8px;
    cursor: pointer;

    span {
      color: #ffffff;
    }
  }

  .marco-upload {
    margin: 40px auto 0px auto;
    max-width: 60%;

    img {
      width: 100%;
      height: 150px;
      border-radius: 8px;
      object-fit: cover;
    }

    h6 {
      text-align: center;
    }
  }

  .userCard {
    margin-top: 20px;
    height: 300px;
    overflow-y: scroll;
    border: solid 1px #d3d5d8;
    box-shadow: none;

    .accordion {
      border: none;
      box-shadow: none;
    }

    .userList {
    }

    ul .userItem {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      align-content: flex-start;

      label {
        margin: 0px;
      }

      .checkbox {
        margin: 0px;
      }
    }
  }
  // estilos migrados de sass
  .grid-2 {
    position: relative;
    display: grid;
    grid-gap: 32px;
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-3 {
    position: relative;
    display: grid;
    grid-gap: 32px;
    grid-template-columns: repeat(3, 1fr);
  }
  label {
    font-size: 16px;
    display: block;
    color: #253858;
    margin-bottom: 4px;
  }
  .inputSelect {
    box-sizing: border-box;
    color: #253858;
    background-color: #fff;
    border: 1px solid #d3d5d8;
    font-size: 16px;
    padding: 10px;
    line-height: 1.7;
    border-radius: 4px;
    margin-bottom: 16px;
    width: 100%;
  }
  .k-widget,
  .k-multiselect {
    min-height: calc(100% - 36px);
    line-height: 1.7;
    border-radius: 4px;
    border: 0.5px solid rgba(0, 0, 0, 0.1);
  }
  #controlSwitch {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: self-end;
  }
`;

const VacancyForm = () => {
  const [state, setState] = React.useState({
    jobTitle: '',
    workType: '',
    seniority: '',
    contract: '',
    category: '',
    typeCurrency: 'MXN',
    checked_Salarios: 'RS',
    jobPayMin: 0,
    jobPayMax: 0,
    jobPay: '',
    data: '',
    img: 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/Preview%2FCulture.jpg?alt=media&token=fedc7601-cb22-4d4e-a168-d82c391064bb',
    isUploading: '',
    progress: '',
    locationName: '',
    carrer: [],
    campus: [],
    notify: false,
  });
  const { t } = useTranslation(['jobs']);
  const [typeCurrencyArray, setTypeCurrencyArray] = React.useState([]);
  const senorities = ['Practicante y Becario', 'Flexible', 'Junior', 'Senior', 'Ejecutivo', 'Otro'];
  const employmentType = ['Freelance', 'Flexible', 'Temporal', 'Medio tiempo', 'Tiempo completo'];
  // Este array es de donde salen las traducciones de categorías, el value del select sigue en español, como siempre */

  // Varibles obteniddas de Redux
  const { carrers, platformCampus } = useSelector((state) => state.platform);
  const { uid } = useSelector((state) => state.auth);
  const { isEdit, editData } = useSelector((state) => state.jobs);
  const dispatch = useDispatch();
  // Metodo para cargar los tipos de monedas

  const loadCoin = async () => {
    try {
      const dataP = (await database.collection('API_data').doc('typeCurrency').get()).data();
      setTypeCurrencyArray(dataP.typeCurrency);
    } catch (e) {
      setTypeCurrencyArray([]);
    }
  };
  const wages = (jobPay) => {
    if (jobPay) {
      if (jobPay === 'Confidencial' || jobPay === 'Negociable') {
        setState((prev) => ({ ...prev, checked_Salarios: jobPay }));
      } else {
        const index = jobPay.indexOf('-');
        if (index > 0) {
          // eslint-disable-next-line camelcase
          const Wage_Min = jobPay.substr(0, index - 1);
          // eslint-disable-next-line camelcase
          const Wage_Max = jobPay.substr(index + 2, jobPay.length);
          setState((prev) => ({
            ...prev,
            jobPayMin: Wage_Min.replace('$', ''),
            jobPayMax: Wage_Max.replace('$', ''),
            checked_Salarios: 'RS',
          }));
        } else {
          setState((prev) => ({ ...prev, jobPayMin: jobPay, jobPayMax: jobPay, checked_Salarios: 'RS' }));
        }
      }
    }
  };

  const editDataForm = () => {
    // Aqui se carga los datos del formulario para editar la vacante
    if (isEdit) {
      wages(editData?.jobPay);
      setState((prev) => ({ ...prev, ...editData }));
    }
  };

  React.useEffect(() => {
    loadCoin().then();
    editDataForm();
    return () => {
      dispatch({
        type: jobTypes.JOBEDITCLEAR,
      });
    };
  }, []);

  const handleTextChange = ({ target }) => {
    const { name, value } = target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleNumberChange = ({ target }) => {
    const { value, name } = target;
    const valueNew = value.replace(/,/gi, '');
    const valinumber = +valueNew;
    if (valinumber || valueNew === '') {
      setState((prev) => ({ ...prev, [name]: valueNew }));
    } else {
      setState((prevState) => ({ ...prevState, [name]: prevState[name] }));
      NotificationManager.error(t('OnlyNumbersAllowed'));
    }

    if (name === 'jobPayMin') {
      setState((prev) => ({ ...prev, jobPay: `$${value} - $${state.jobPayMax}` }));
    }
    if (name === 'jobPayMax') {
      setState((prev) => ({ ...prev, jobPay: `$${state.jobPayMin} - $${value}` }));
    }
  };

  const sendData = (data) => setState((prev) => ({ ...prev, data }));

  const updloadImage = async ({ target }) => {
    dispatch(onChangeLoad(false));
    const { files } = target;
    const time = moment().valueOf();
    const name = `companies/${uid}/logo/vacancy/${time}`;
    await storage.ref(name).put(files[0]);
    const url = await storage.ref(name).getDownloadURL();
    setState((prev) => ({ ...prev, img: url }));
    dispatch(onChangeLoad(true));
  };

  const returnLatLang = async (ll, local) => {
    setState((prev) => ({ ...prev, locationName: local, latlang: { ...ll } }));
  };

  const onSave = () => {
    const { jobTitle } = state;
    if (jobTitle !== '') {
      dispatch(onChangeLoad(false));
      if (!isEdit) {
        dispatch(createNew(state));
      } else {
        dispatch(updateVacancy(state));
      }
    } else {
      NotificationManager.error('Existen Datos vacíos');
    }
  };

  const onCheckSwitch = ({ target }) => {
    const { name, checked } = target;
    setState((prev) => ({ ...prev, [name]: checked }));
  };

  return (
    <ContainerForm>
      <form>
        <div className="grid-2" style={{ gridRowGap: 10 }}>
          <div>
            <label>{t('Name')}</label>
            <input
              type="text"
              placeholder="Sr. React Developer"
              name="jobTitle"
              maxLength={40}
              value={state.jobTitle}
              className="inputSelect"
              onChange={(e) => handleTextChange(e)}
              style={{
                marginBottom: '0',
              }}
            />
          </div>
          <div>
            <label>
              {t('Wage')} (
              <select
                className="typeCurrency"
                value={state.typeCurrency}
                name="typeCurrency"
                onChange={(e) => handleTextChange(e)}>
                {typeCurrencyArray.map((coin) => {
                  return (
                    <Tooltip title={coin.info}>
                      <option value={coin.coin}>{coin.info}</option>
                    </Tooltip>
                  );
                })}
              </select>
              )
            </label>
            <div className="salary">
              <button
                type="button"
                name="checked_Salarios"
                className={state.checked_Salarios === 'RS' ? 'salary_selected' : ''}
                onClick={handleTextChange}
                value="RS">
                {t('Range')}
              </button>
              <button
                type="button"
                name="checked_Salarios"
                className={state.checked_Salarios === 'Negociable' ? 'salary_selected' : ''}
                onClick={handleTextChange}
                value="Negociable">
                {t('Negotiable')}
              </button>
            </div>
          </div>
          <div className={state.checked_Salarios !== 'RS' ? 'hidden inputSalarios' : 'visible inputSalarios'}>
            <div>
              <label className={state.checked_Salarios !== 'RS' ? 'hidden' : 'visible'}>{t('Minimum')}</label>
              <input
                type="text"
                className={state.checked_Salarios !== 'RS' ? 'hidden inputSelect' : 'inputSelect visible'}
                placeholder="Minimo"
                name="jobPayMin"
                disabled={state.checked_Salarios !== 'RS'}
                value={new Intl.NumberFormat('es-MX').format(state.jobPayMin)}
                onChange={handleNumberChange}
              />
            </div>

            <div>
              <label className={state.checked_Salarios !== 'RS' ? 'hidden' : 'visible'}>{t('Maximum')}</label>
              <input
                type="text"
                placeholder="Maximo"
                name="jobPayMax"
                className={state.checked_Salarios !== 'RS' ? ' inputSelect hidden' : 'inputSelect visible'}
                disabled={state.checked_Salarios !== 'RS'}
                value={new Intl.NumberFormat('es-MX').format(state.jobPayMax)}
                onChange={handleNumberChange}
              />
            </div>
          </div>
          <div>
            {/* Tener cuidado con el código agregado para las traducciones */}
            <label>{t('Contract')}</label>
            <select name="contract" value={state.contract} onChange={handleTextChange} id="">
              {employmentType.map((type) => (
                <option value={type} key={type}>
                  {
                    // eslint-disable-next-line no-nested-ternary
                    type === 'Medio tiempo' ? t('HalfTime') : type === 'Tiempo completo' ? t('FullTime') : t(type)
                  }
                </option>
              ))}
            </select>
          </div>
          <div>
            <label>{t('Carrer')}</label>
            <MultiSelect
              name="carrer"
              allowCustom
              value={state.carrer}
              onChange={handleTextChange}
              data={carrers}
            />
          </div>
          <div>
            <label>{t('Seniority')}</label>
            <select name="seniority" value={state.seniority} onChange={handleTextChange} id="">
              {senorities.map((type) => (
                <option value={type} key={type}>
                  {type}
                </option>
              ))}
            </select>
          </div>
          {platformCampus?.length ? (
            <div>
              <label>{t('campus')}</label>
              <MultiSelect
                name="campus"
                allowCustom
                value={state.campus}
                onChange={handleTextChange}
                data={platformCampus}
              />
            </div>
          ) : null}
          <div className="form-group">
            <label>{t('Address')}</label>
            <LocationSearchInput returnLatLang={returnLatLang} prefill={state.locationName} />
          </div>
          <FormGroup row style={{ display: 'flex', alignItems: 'flex-end' }}>
            <FormControlLabel
              control={<Checkbox checked={state.notify} onChange={onCheckSwitch} name="notify" />}
              label="Notificarme"
              color="primary"
            />
          </FormGroup>
        </div>
        <div>
          <label style={{ marginTop: 10 }}>{t('Description')}</label>
          <Editor upstream={state.data || ''} sendData={sendData} placeholder="Ingrese una descripción" />
        </div>
      </form>
      {/* Datos de imagen  */}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div id="controlSwitch">
          <div />
          <button type="button" id="saveButton" onClick={onSave}>
            {t('Publish')}
          </button>
        </div>
        <div className="jobcard">
          <img src={state.img} alt="" />
          <div className="jobcard-container">
            <h3>{state.companyName?.toUpperCase() || ''}</h3>
            <h4>{state.jobTitle || t('AssignVacancysName')}</h4>
          </div>
        </div>
        <div className="marco-upload">
          <img src={state.img} alt="" />

          <div className="upload">
            <div>
              <label htmlFor="upLoadfiles">
                <span style={{ cursor: 'pointer' }}>
                  <CloudUploadFill size={20} color={palette.white} />
                  {state.isUploading ? state.progress : t('UploadCustom')}
                </span>
              </label>
              <input
                type="file"
                id="upLoadfiles"
                name="upLoadfiles"
                accept=".png, .jpg"
                style={{ display: 'none' }}
                onChange={(e) => updloadImage(e)}
              />
            </div>
          </div>
          <h6 style={{ fontSize: '14px', marginTop: '10px' }}>*{t('HorizontalImg')}.</h6>
        </div>
      </div>
    </ContainerForm>
  );
};

export default VacancyForm;
